// NGRX
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
// Actions
import {LocationDescriptionActions, LocationDescriptionActionTypes} from '../_actions/location-description.actions';
// Models
import {LocationDescription} from '../_models/location-description.model';
import {QueryParamsModel} from '../../_base/crud';

export interface LocationDescriptionsState extends EntityState<LocationDescription> {
    isAllLocationDescriptionsLoaded: boolean;
    queryRowsCount: number;
    queryResult: LocationDescription[];
    lastCreatedLocationDescriptionId: number;
    listLoading: boolean;
    actionLoading: boolean;
    totalCount: number;
    totalTrashed: number;
    totalAdminTrashed: number;

    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<LocationDescription> = createEntityAdapter<LocationDescription>();

export const initialLocationDescriptionsState: LocationDescriptionsState = adapter.getInitialState({
    isAllLocationDescriptionsLoaded: false,
    queryRowsCount: 0,
    queryResult: [],
    lastCreatedLocationDescriptionId: undefined,
    listLoading: false,
    actionLoading: false,
    totalCount: 0,
    totalTrashed: 0,
    totalAdminTrashed: 0,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true
});

export function locationDescriptionsReducer(state = initialLocationDescriptionsState, action: LocationDescriptionActions): LocationDescriptionsState {
    switch (action.type) {
        case LocationDescriptionActionTypes.LocationDescriptionsPageToggleLoading:
            return {
                ...state, listLoading: action.payload.isLoading, lastCreatedLocationDescriptionId: undefined
            };
        case LocationDescriptionActionTypes.LocationDescriptionsActionToggleLoading:
            return {
                ...state, actionLoading: action.payload.isLoading
            };
        case LocationDescriptionActionTypes.LocationDescriptionOnServerCreated:
            return {
                ...state
            };
        case LocationDescriptionActionTypes.LocationDescriptionCreated:
            return adapter.addOne(action.payload.locationDescription, {
                ...state, lastCreatedLocationDescriptionId: action.payload.locationDescription.id
            });
        case LocationDescriptionActionTypes.LocationDescriptionUpdated:
            return adapter.updateOne(action.payload.partialLocationDescription, state);
        case LocationDescriptionActionTypes.AllLocationDescriptionsLoaded:
            return adapter.addAll(action.payload.locationDescriptions, {
                ...state, isAllLocationDescriptionsLoaded: true
            });
        case LocationDescriptionActionTypes.LocationDescriptionsPageCancelled:
            return {
                ...state, listLoading: false, queryRowsCount: 0, queryResult: [], lastQuery: new QueryParamsModel({})
            };
        case LocationDescriptionActionTypes.LocationDescriptionsPageLoaded:
            return adapter.addMany(action.payload.locationDescriptions, {
                ...initialLocationDescriptionsState,
                totalCount: action.payload.totalCount,
                totalTrashed: action.payload.totalTrashed,
                totalAdminTrashed: action.payload.totalAdminTrashed,
                listLoading: false,
                lastQuery: action.payload.page,
                showInitWaitingMessage: false
            });
        case LocationDescriptionActionTypes.LocationDescriptionDeleted:
            return adapter.removeOne(action.payload.id, {
                ...state, totalTrashed: state.totalTrashed + 1
            });

        case LocationDescriptionActionTypes.LocationDescriptionRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalTrashed: state.totalTrashed - 1
            });

        case LocationDescriptionActionTypes.LocationDescriptionDeletedFromTrash:
            return {
                ...state, totalTrashed: state.totalTrashed - 1, totalAdminTrashed: state.totalAdminTrashed + 1
            };

        // Admin Trash Action
        case LocationDescriptionActionTypes.LocationDescriptionAdminRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            });

        case LocationDescriptionActionTypes.LocationDescriptionDeletedFromAdminTrash:
            return {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            };
        case LocationDescriptionActionTypes.LocationDescriptionTrashFlushed:
            return {
                ...state, totalTrashed: 0, totalAdminTrashed: state.totalAdminTrashed + state.totalTrashed
            };
        default:
            return state;
    }
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
